import React, { FC, ReactNode } from "react";
import { TenantLogoImage } from "@/components/common/TenantLogoImage";

interface TenantLogoImageWithPlaceholderProps {
  placeholder: ReactNode;
  logoKey?: string | null;
  className?: string;
  alt?: string;
}

export const TenantLogoImageWithPlaceholder: FC<
  TenantLogoImageWithPlaceholderProps
> = ({ logoKey, placeholder, className, alt }) => {
  if (logoKey) {
    return (
      <TenantLogoImage
        className={className}
        alt={alt || "Image"}
        logoKey={logoKey}
      />
    );
  }

  return <>{placeholder}</>;
};
